import { basemapInkFor } from '~/client/src/shared/map/labelLayerStyle'
import Markup from '~/client/src/shared/models/Markup'

import { groundFillsFromMarkups } from '../MapMarkups/markupGroundFills'
import MapViewItemBase from '../SitemapHelpers/models/MapViewItemBase'
import { groundFillsFromLocations } from '../SitemapHelpers/utils/locationGroundFills'
import { IGroundContext } from './labelGroundTone'

// What each label actually stands on, composited from the scene rather than measured from the
// rendered picture: the basemap by identity, then every filled shape in paint order. Location
// shapes draw at layer 11 and markups at 21, so a markup over a zone wins the ground the way it
// does on screen.
export function composeLabelGround(
  isSatellite: boolean,
  locationItems: MapViewItemBase[],
  markups: Markup[],
): IGroundContext {
  return {
    basemap: basemapInkFor(isSatellite),
    fills: [
      ...groundFillsFromLocations(locationItems),
      ...groundFillsFromMarkups(markups),
    ],
  }
}
